"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MutationFunctionHandler = _interopRequireDefault(require("./MutationFunctionHandler"));
/**
 * A MutationFunctionHandler for insertions.
 */


var InsertFunctionHandler =
/*#__PURE__*/
function (_MutationFunctionHand) {
  _inherits(InsertFunctionHandler, _MutationFunctionHand);

  function InsertFunctionHandler() {
    _classCallCheck(this, InsertFunctionHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(InsertFunctionHandler).call(this, 'INSERT', false));
  }

  return InsertFunctionHandler;
}(_MutationFunctionHandler.default);

exports.default = InsertFunctionHandler;